import React, { useState, useCallback, useEffect } from 'react';
import { getList } from 'services/recruitment.service';
import { defaultPaging, defaultParams, showToast } from 'utils/helpers';
import RecruitmentTable from './components/main/RecruitmentTable';
import RecruitmentFilter from './components/main/RecruitmentFilter';

const RecruitmentPage = () => {
  const [loading, setLoading] = useState(false);
  const [params, setParams] = useState(defaultParams);
  const [dataList, setDataList] = useState(defaultPaging);

  const { items, itemsPerPage, page, totalItems, totalPages } = dataList;

  const loadData = useCallback(() => {
    setLoading(true);
    getList(params)
      .then(setDataList)
      .catch((err) => {
        showToast.error(err?.message ?? 'Có lỗi xảy ra');
      })
      .finally(() => {
        setLoading(false);
      });
  }, [params]);
  useEffect(loadData, [loadData]);

  return (
    <React.Fragment>
      <div class='bw_main_wrapp'>
        <RecruitmentFilter
          onChange={(e) => {
            setParams((prev) => {
              return {
                ...prev,
                ...e,
              };
            });
          }}
        />
        <RecruitmentTable
          loading={loading}
          data={items}
          totalPages={totalPages}
          itemsPerPage={itemsPerPage}
          page={page}
          totalItems={totalItems}
          onChangePage={(page) => {
            setParams({
              ...params,
              page,
            });
          }}
          onRefresh={loadData}
        />
      </div>
    </React.Fragment>
  );
};

export default RecruitmentPage;
